import React from "react";

export default function String({ fill, className }) {
    return (
        <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="16" height="16" fill="transparent" />
            <g clip-path="url(#clip0_334_50)">
                <path d="M13.5374 6.87804V3.7132C13.5374 3.5034 13.454 3.30214 13.3057 3.15371C13.1572 3.00536 12.9559 2.922 12.7462 2.922H3.25166C3.04185 2.922 2.84059 3.00536 2.69216 3.15371C2.54381 3.30215 2.46045 3.5034 2.46045 3.7132V6.87804H13.5374Z" fill={fill ? fill : "#8F94A6"} />
                <path d="M6.41626 11.2297H9.5811V13.9989H6.41626V11.2297Z" fill={fill ? fill : "#8F94A6"} />
                <path d="M10.3722 7.66917H13.5371V10.4384H10.3722V7.66917Z" fill={fill ? fill : "#8F94A6"} />
                <path d="M2.46045 7.66917H5.62528V10.4384H2.46045V7.66917Z" fill={fill ? fill : "#8F94A6"} />
                <path d="M6.41626 7.66917H9.5811V10.4384H6.41626V7.66917Z" fill={fill ? fill : "#8F94A6"} />
                <path d="M10.3722 11.2297V13.9989H12.7458C12.9556 13.9989 13.1568 13.9156 13.3053 13.7672C13.4537 13.6187 13.5371 13.4175 13.5371 13.2077V11.2297H10.3722Z" fill={fill ? fill : "#8F94A6"} />
                <path d="M5.62528 11.2297H2.46045V13.2077C2.46045 13.4175 2.54381 13.6188 2.69216 13.7672C2.8406 13.9156 3.04185 13.9989 3.25166 13.9989H5.62528V11.2297Z" fill={fill ? fill : "#8F94A6"} />
            </g>
            <defs>
                <clipPath id="clip0_334_50">
                    <rect width="11.0769" height="12" fill="white" transform="translate(2.46155 2)" />
                </clipPath>
            </defs>
        </svg>
    );
}
